import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LeadSquaredWriterForm from '../forms/lead-squared-writer-form';
import { leadSquaredWriterValidationSchema } from '../schema/leadSquaredWriter.js';

export default function LeadSquaredWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'LeadSquared Writer Node Details',
        altText: 'LeadSquared Writer Node',
        defaultLabel: 'LeadSquared Writer Node',
      }}
    >
      <CommonNode
        FormComponent={LeadSquaredWriterForm}
        schemaResolver={leadSquaredWriterValidationSchema}
      />
    </NodeProvider>
  );
}
